const upper = (id: unknown): string => String(id ?? '').trim().toUpperCase();
export const DISMISS_SUMMON = '8C7CDFC0-E251-4CD3-ACA8-70F095746621';
export const RECALL_SUMMON = '73AF8EC0-6717-475A-B272-15B2542C91E0';
export const REVERT_SHAPESHIFT = '84DA8D8C-7B6D-444E-B76F-8B174B14A6C0';
export const PARALYZED = 'BF31EE0A-5B3C-370B-0118-96B067CFD929';
export const creatureControl = (id: unknown): boolean => [DISMISS_SUMMON, RECALL_SUMMON, REVERT_SHAPESHIFT].includes(upper(id));
